var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGitterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "50px",
    viewBox: "0 0 60 50",
    enableBackground: "new 0 0 60 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.397,7.784c-0.413,0-0.748,0.335-0.748,0.749v20.21c0,0.414,0.335,0.748,0.748,0.748h2.994 c0.413,0,0.749-0.334,0.749-0.748V8.533c0-0.414-0.336-0.749-0.749-0.749H18.397z M25.134,13.023c-0.413,0-0.749,0.334-0.749,0.748 v27.695c0,0.414,0.336,0.749,0.749,0.749h2.994c0.413,0,0.748-0.335,0.748-0.749V13.771c0-0.414-0.335-0.748-0.748-0.748H25.134z  M31.87,13.023c-0.413,0-0.748,0.334-0.748,0.748v27.695c0,0.414,0.335,0.749,0.748,0.749h2.994c0.413,0,0.749-0.335,0.749-0.749 V13.771c0-0.414-0.336-0.748-0.749-0.748H31.87z M38.607,13.023c-0.413,0-0.749,0.334-0.749,0.748v14.972 c0,0.414,0.336,0.748,0.749,0.748h2.994c0.412,0,0.749-0.334,0.749-0.748V13.771c0-0.414-0.337-0.748-0.749-0.748H38.607z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitterLogo);
export default __webpack_public_path__ + "static/media/gitter-logo.cb04235e.svg";
export { ForwardRef as ReactComponent };